import { useCallback } from 'react';
import toast from 'react-hot-toast';

import { NotificationBanner } from '../notification-banner/NotificationBanner';
import { PromiseNotificationBanner } from '../notification-banner/PromiseNotificationBanner';
import type { NotificationDetail } from './types';

export const useNotifications = () => {
  // Stable identity: `addNotification` is a common effect dependency (e.g.
  // useErrorNotification), and a fresh function every render re-fires those
  // effects on every render — stacking non-expiring toasts while an error is
  // set. The callback closes over nothing render-scoped, so `[]` is correct.
  const addNotification = useCallback((notification: NotificationDetail) => {
    switch (notification.type) {
      case 'success':
        toast.custom(
          (t) => (
            <NotificationBanner
              {...notification}
              toast={t}
              durationMs={3500}
              dismissable={true}
            />
          ),
          {
            duration: Infinity,
          }
        );
        break;
      case 'error':
        toast.custom(
          (t) => (
            <NotificationBanner
              {...notification}
              toast={t}
              durationMs={Infinity}
              dismissable={true}
            />
          ),
          {
            duration: Infinity,
          }
        );
        break;
      case 'promise':
        toast.custom(
          (t) => <PromiseNotificationBanner {...notification} toast={t} />,
          {
            duration: Infinity,
          }
        );
        break;
      default:
        toast(
          (t) => (
            <NotificationBanner
              {...notification}
              toast={t}
              durationMs={3500}
              dismissable={true}
            />
          ),
          {
            duration: Infinity,
          }
        );
    }
  }, []);

  return { addNotification };
};
